import { jsx as n } from "react/jsx-runtime";
import { RouterAbstractionContext as i } from "./context.js";
import { DEFAULT_STATE as m, useAbstractedLink as k, useAsbstractedHistory as p, useRouterAbstraction as L } from "./context.js";
const c = (o) => function({ to: t, href: r, ...s }) {
  return /* @__PURE__ */ n(o, { ...s, to: t || r, href: t || r });
}, A = ({
  children: o,
  linkComponent: e,
  history: t
}) => {
  const r = c(e);
  return /* @__PURE__ */ n(
    i.Provider,
    {
      value: { linkComponent: r, history: t },
      children: o
    }
  );
};
export {
  m as DEFAULT_STATE,
  i as RouterAbstractionContext,
  A as RouterAbstractionProvider,
  c as createAbstractedLink,
  k as useAbstractedLink,
  p as useAsbstractedHistory,
  L as useRouterAbstraction
};
